<template>
  <div class="content">
    <div v-if="!question">
      <placeholder title="Loading question"></placeholder>
    </div>
    <div v-else>
      <div class="row">
        <div class="col-6">
          <h2 class="font-light">Edit Question</h2>
        </div>
        <div class="col-6 u-vertical-center">
          <!-- Action Buttons -->
          <div class="form-group">
            <a href="#question-preview" class="action-button">
              <button class="btn-light">
                <span class="icon">
                  <i class="fa-wrapper fa fa-glasses"></i>
                </span>
                <span>Preview</span>
              </button>
            </a>
            <button
              class="btn-primary action-button"
              v-on:click="save"
              v-bind:disabled="canChange(question)"
            >
              <loading-spinner v-show="saving"></loading-spinner>
              <span class="icon">
                <i class="fa-wrapper fa fa-upload" v-show="!saving"></i>
              </span>
              Save
            </button>
            <button class="btn-info action-button">
              <router-link :to="{ name: 'question-index' }">
                <span class="icon">
                  <i class="fa-wrapper fa fa-reply normal-icon pad-right"></i>
                </span>
                <span>Index</span>
              </router-link>
            </button>
          </div>
        </div>
        <div class="col-12 info u-text-right" v-if="question.read_only">
          This question is <strong>Ready Only</strong> and can't be changed
        </div>
      </div>
      <toast-success
        v-if="success"
        v-bind:label="'Question Saved'"
        v-bind:message="'The Question was successfully saved on the server.'"
        v-on:close="closeSuccess"
      ></toast-success>
      <server-error v-bind:error="error.serverError"></server-error>
      <question-info v-bind:question="question"></question-info>
      <!-- The form to edit the question -->
      <question-form
        v-bind:question="question"
        v-bind:error="error"
        v-bind:canChange="canChange(question)"
        v-on:save="save"
      ></question-form>
      <div class="panel">
        <div class="btn-container u-fill-width u-text-right">
          <button
            class="btn-primary action-button"
            v-on:click="save"
            v-bind:disabled="canChange(question)"
          >
            <loading-spinner v-show="saving"></loading-spinner>
            <span class="icon">
              <i class="fa-wrapper fa fa-upload" v-show="!saving"></i>
            </span>
            Save
          </button>
          <div class="info" v-if="question.read_only">
            This question is <strong>Ready Only</strong> and can't be changed
          </div>
        </div>
      </div>
    </div>
    <question-preview :question="question"></question-preview>
  </div>
</template>
<style>
table {
  border: 1px solid rgba(219, 219, 219, 0.5);
}
.tag-container .tag {
  margin-top: 0.25rem;
  margin-bottom: 0 !important;
}
.btn-container button {
  margin-left: 1rem;
}
</style>
<script>
import { mapGetters } from "vuex";
import Placeholder from "@/components/Placeholder";
import QuestionForm from "@/components/questions/QuestionForm";
import QuestionInfo from "@/components/questions/QuestionInfo";
import QuestionPreview from "@/components/questions/QuestionPreview";
import ServerError from "@/components/ServerError";
import ToastSuccess from "@/components/ToastSuccess";
import { scrollToTop } from "@/functions/scrollToTop";
import LoadingSpinner from "@/components/LoadingSpinner";

export default {
  name: "question-edit",
  components: {
    Placeholder,
    QuestionForm,
    QuestionInfo,
    QuestionPreview,
    ServerError,
    ToastSuccess,
    LoadingSpinner
  },
  data: function() {
    return {
      saving: false,
      success: false
    };
  },
  computed: {
    question: function() {
      var result = this.$store.getters["questions/question"](
        this.$route.params.id
      );
      if (result.id && result.id != this.$route.params.id) {
        // If the question has changed (e.g. when a question that is in an exam
        // has been edited) re-direct to the new question which was returned by
        // the server =)
        this.$router.replace({ name: "question", params: { id: result.id } });
      }
      return result;
    },
    ...mapGetters("core", ["error"]),
    ...mapGetters("auth", ["permissions"])
  },
  methods: {
    validate() {
      if (!this.question.topic) {
        this.$store.commit("core/setError", {
          topic: "A topic must be selected."
        });
        return false;
      }
      return true;
    },
    canChange: function(question) {
      return (
        question.read_only ||
        !this.permissions.includes("exams.change_question")
      );
    },
    save() {
      scrollToTop();
      this.$store.commit("core/clearErrors");
      this.success = false;
      const is_valid = this.validate();
      if (!is_valid) {
        return;
      }
      this.saving = true;
      this.$store
        .dispatch("questions/saveQuestion", this.question)
        .then(result => {
          this.saving = false;
          this.success = result;
        });
    },
    closeSuccess: function() {
      this.success = false;
    }
  },
  mounted() {
    this.$store.dispatch("questions/getQuestion", {
      id: this.$route.params.id
    });
  }
};
</script>
